import "@vertexvis/viewer/dist/viewer/viewer.css";

import { AppProps } from "next/app";
import Head from "next/head";
import { useRouter } from "next/router";
import React from "react";

import { Inter, Lexend, Roboto } from 'next/font/google'
import clsx from 'clsx'

import "@vertexvis/viewer/dist/viewer/viewer.css";
import '@/styles/tailwind.css'
import { RecoilRoot } from "recoil";
import { catalogIdAtom } from "@/lib/state/catalogState";
import { getConfiguration } from "@/lib/vertex/vertexConfig";
import { useUrlFragmentSync } from "@/app/useUrlFragmentSync";

const inter = Inter({ subsets: ['latin'] });
const lexend = Lexend({ subsets: ['latin'] });
const roboto300 = Roboto( {weight: "300", subsets: ['latin']});
const roboto400 = Roboto( {weight: "400", subsets: ['latin']});
const roboto500 = Roboto( {weight: "500", subsets: ['latin']});
const roboto700 = Roboto( {weight: "700", subsets: ['latin']});

export default function App({ Component, pageProps, router }: AppProps): JSX.Element {
  const { events } = useRouter();

  React.useEffect(() => {
    function handleChange(url: string) {
      // // @ts-ignore
      // if (window.gtag) {
      //   // @ts-ignore
      //   window.gtag("config", process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS, {
      //     cookie_flags: "SameSite=None;Secure",
      //     page_path: url,
      //   });
      // }
      console.log(`URL CHANGED: ${url}`);
    }

    events.on("routeChangeComplete", handleChange);
    return () => {
      events.off("routeChangeComplete", handleChange);
    };
  }, [events]);

  return (
    <RecoilRoot initializeState={({set}) => {
  set(catalogIdAtom, (typeof window !== 'undefined' && window.location.hash?.length > 1) ? window?.location.hash.slice(1) : getConfiguration().defaultCatalog);
} }>
      <main className={clsx(inter.className, lexend.className, roboto300.className, roboto400.className, roboto500.className, roboto700.className)}>
          <Head>
            <title>Vertex 3D E-Commerce Demo</title>
            <link rel="icon" href="/favicon-512x512.png" />
            <meta
              name="viewport"
              content="minimum-scale=1, initial-scale=1, width=device-width"
            />
            <meta
              name="description"
              content="Vertex 3D is better e-commerce for everyone."
            />
          </Head>
            <Component {...pageProps} />
        </main>
      </RecoilRoot>
  );
}
